import { render } from "./CropMecanicForm.vue?vue&type=template&id=60205005&scoped=true&ts=true"
import script from "./CropMecanicForm.vue?vue&type=script&lang=ts"
export * from "./CropMecanicForm.vue?vue&type=script&lang=ts"

import "./CropMecanicForm.vue?vue&type=style&index=0&id=60205005&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60205005"]])

export default __exports__